import {getAllProjects, getProjectList, getProjectListBYID, getProjectOwner, detailProject} from "../../api/listProjects";

const state = () => ({

    listProjects:[],
    SUProjects:{}, //SUProjects = selectedUser_Projects,
    allProjects: {},
    listOwner: {},
    detailProject: {}

})

const getters = {
    get_listProjects(state) {
        return state.listProjects;
    },
    get_SUProjects(state) {
        return state.SUProjects;
    },
    get_allProjects(state){
        return state.allProjects
    },
    get_ownerList(state){
        return state.listOwner
    },
    get_detail_project(state){
        return state.detailProject
    }
}

const mutations = {
    SET_LISTPROJECTS(state,data){
        state.listProjects = data;},
    SET_SUPROJECTS(state,data){
        state.SUProjects = data;
    },
    SET_ALLPROJECTS(state, data){
        state.allProjects = data
    },
    SET_OWNER_LIST(state,data){
        state.listOwner = data
    },
    SET_DETAIL_PROJECT(state,data){
        state.detailProject = data
    }
}

const actions = {
    async fetchListProjects({ commit }) {
        const response = await getProjectList();
        commit('SET_LISTPROJECTS', response.data.data);
    },
    async fetchSUProjects({ commit },params) {
        try {
            
            let response = await getProjectListBYID(params);
            commit('SET_SUPROJECTS', response.data);
        }catch (e) {
        //
        }


    },
    async fetchAllProjects({commit}, params){
        try {
            let res = await getAllProjects(params)
            commit('SET_ALLPROJECTS', res.data)
        }catch (e){
            //
        }
    },
    async fetchOwner({commit}, params){
        try {
            let res = await getProjectOwner(params)
            commit('SET_OWNER_LIST', res.data)
        }
        catch (e){
            //
        }
    },
    async fetchDetailProject({commit}, params){
        try {
            let res = await detailProject(params)
            commit('SET_DETAIL_PROJECT', res.data)
        }
        catch (e){
            //
        }
    }

}




export  default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
